<section class="section">
  <div class="section-content">
    <div class="section-main">
      <div class="section-text-header-container section-5-text-header-container">
        <text-header i18n>Kto czyta, nie błądzi</text-header>
        <text i18n
          >Z myślą o tym, że pewnie będziesz chciał/chciała się rozwijać, przygotowaliśmy dla Ciebie
          bazę wiedzy pełną artykułów z zakresu zdrowia psychicznego.</text
        >
        <colorful-button i18n-label label="poczytajmy" (buttonClick)="onRead()" class="read-button"/>
      </div>
    </div>
  </div>
</section>
